export default __webpack_public_path__ + "static/media/1.a04f9e8c.png";